<template>
    <animation>
        <div class="circles">
            <img class="img" src="../assets/circles.png"/>
        </div>
    </animation>
</template>

<script>
import Animation from './Animation.vue'
export default {
    name: "Circles",
    components: { 
        Animation 
    },
}
</script>

<style scoped>
.circles {
    height:75px;
}
.img {
    width: 100px;
    opacity: 0.7;
}
</style>